import { useApi } from '@/api';
import { ChartTimeFilter, ChartSkeleton } from '@/components';
import { formatNumber, FormattedNumber, LineChart } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useChartPeriod } from '@/hooks';

export default function SSRDepositorsChart() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const yAxisConfig = {
    options: {
      scales: {
        y: {
          ticks: {
            stepSize: 1
          }
        }
      }
    }
  };
  const config = updateChartConfigWithPeriod(yAxisConfig);
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: '/save/ssr/historic/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <LineChart
        key={'Depositors'}
        data={data.historic}
        datasets={[
          {
            xField: 'date',
            yField: 'depositors'
          }
        ]}
        valueFormatter={(value: number) => (
          <FormattedNumber
            value={Number(value)}
            options={{ formatNumberOptions: { notation: 'standard' } }}
          />
        )}
        yScaleValueFormatter={(value: number) => formatNumber(value)}
        timeFilter={timeFilter}
        config={config}
      />
    );
  }

  return <ChartSkeleton />;
}
